/* The mockup's call icons, line for line. */
const svg = function (w, body, attrs) {
  if (attrs === void 0) {
    attrs = 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
  }
  return m.trust(`<svg width="${w}" height="${w}" viewBox="0 0 24 24" ${attrs} aria-hidden="true">${body}</svg>`);
};
export default {
  phone: function (w) {
    if (w === void 0) {
      w = 17;
    }
    return svg(w, '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/>');
  },
  video: function (w) {
    if (w === void 0) {
      w = 18;
    }
    return svg(w, '<path d="m23 7-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/>');
  },
  headphones: function (w) {
    if (w === void 0) {
      w = 16;
    }
    return svg(w, '<path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>');
  },
  mic: function (w) {
    if (w === void 0) {
      w = 20;
    }
    return svg(w, '<rect x="9" y="2" width="6" height="12" rx="3"/><path d="M19 10v1a7 7 0 0 1-14 0v-1M12 18v4"/>');
  },
  micoff: function (w) {
    if (w === void 0) {
      w = 20;
    }
    return svg(w, '<path d="m2 2 20 20M9 9v2a3 3 0 0 0 5.1 2.1M15 9.3V5a3 3 0 0 0-5.9-.7M19 10v1a7 7 0 0 1-1.1 3.8M5 10v1a7 7 0 0 0 11.6 5.3M12 18v4"/>');
  },
  share: () => svg(20, '<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4M9 10l3-3 3 3M12 7v6"/>'),
  end: () => svg(22, '<path d="M12 9c-1.6 0-3.2.3-4.6.7v3.1c0 .4-.2.7-.6.9-1 .5-1.9 1.1-2.7 1.8-.2.2-.4.3-.7.3s-.5-.1-.7-.3L.3 13.1c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7C3.3 8.9 7.4 7.2 12 7.2s8.7 1.7 11.7 4.5c.2.2.3.4.3.7s-.1.5-.3.7l-2.4 2.4c-.2.2-.4.3-.7.3s-.5-.1-.7-.3c-.8-.7-1.7-1.3-2.7-1.8-.3-.2-.6-.5-.6-.9V9.7C15.2 9.3 13.6 9 12 9z"/>', 'fill="currentColor"'),
  pip: () => svg(18, '<rect x="2" y="4" width="20" height="16" rx="2"/><rect x="12" y="12" width="7" height="5" rx="1" fill="currentColor"/>', 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"'),
  expand: () => svg(16, '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>'),
  lock: () => svg(12, '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>', 'fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"'),
  relay: () => svg(12, '<path d="M4 12h16M14 6l6 6-6 6"/>', 'fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"')
};